import { CardFiled, CROPPED_DIVIDER_TYPE, DIVIDER_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ICardFieldProps } from "../cards/CardField"
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"

/* Protopia Ecosystem component */
const CardFieldCroppedDivider = (props: ICardFieldProps): JSX.Element => { 
    const { value, field, section, i } = props
    const data: CardFiled = field 
    
    useEffect(() => {
        addCSSClass(
            `cropped-divider-${section.id}`,
            `.cropped-divider-${section.id} {
                width: ${getCssDemention(data.divider_width, "100%")}!important;
                border-color: ${data.divider_color}!important;
                background-color: ${
                    data.divider_type === DIVIDER_TYPE.BOLD_LINE 
                        ?
                        data.divider_color
                        :
                        "transparent"
                }!important;
                height: ${
                    data.divider_type !== DIVIDER_TYPE.LINE
                        ?
                        getCssDemention(data.divider_height, "20px") + "!important"
                        :
                        0
                };
            }            
            `
        )
    },[])
    
    return <div 
        className={`landing-card-field landing-card-field-cropped-divider ${value.className || ""}`} 
        style={{ ...field.style, ...value.style }} 
        data-card-field-id={i}
        card-field-section-id={section.id}
    >
        <CroppedDivider {...props} />
    </div>
}
export default CardFieldCroppedDivider


const CroppedDivider = (props:ICardFieldProps) : JSX.Element => {
    const { section, field, cardOrder, value, i } = props
    const data: CardFiled = field
    const composition = useComposition(section)  
    
    useEffect(() => {
        addCSSClass(
            `c-divider-${section?.id}-${cardOrder}`,
            `.c-divider-${section?.id}-${cardOrder} {

            }
            .c-divider-${section?.id}-${cardOrder} > svg {
                width: ${composition.columns * 100}%;
                transform: translateX(-${( cardOrder % composition.columns) * (100 / composition.columns)}%) scaleY(0.5);
                transform-origin: top;
            }`
        )
    }, [])
    switch(field.divider_type) {
        case CROPPED_DIVIDER_TYPE.WAVE_OUTLINE:
            return <div className={`divider-cropped-divider c-divider-${section?.id}-${cardOrder}`}>
                <svg 
                    version="1.1" 
                    xmlns="http://www.w3.org/2000/svg" 
                    xmlnsXlink="http://www.w3.org/1999/xlink" 
                    x="0px" 
                    y="0px"
                    viewBox={`0 0 377.2 59.5`} xmlSpace="preserve"
                >
                    <path fill={value.style?.fill || field.divider_color} d="M377.2,28.6c-3.7-2.5-23.7-15.6-54.1-22.4c-31-6.9-79.5-8.6-134.5,22.8C133.9,60.3,85.4,58.7,54.3,51.7
                        C22.1,44.6,1.5,30.5-0.5,29.1V30c3.7,2.5,23.9,15.6,54.6,22.4c10.8,2.4,23.6,4.2,38.1,4.2c27.5,0,60.8-6.4,96.8-27
                        C243.7-1.7,292,0,322.9,6.9c32,7.1,52.4,21.2,54.3,22.6V28.6z"
                    />
                </svg>
            </div>
        case CROPPED_DIVIDER_TYPE.WAVE_OUTLINE_REVERSE:
            return <div className={`divider-cropped-divider c-divider-${section?.id}-${cardOrder}`}>
                <svg 
                    version="1.1" 
                    xmlns="http://www.w3.org/2000/svg" 
                    xmlnsXlink="http://www.w3.org/1999/xlink" 
                    x="0px" 
                    y="0px"
                    viewBox={`0 0 377.2 59.5`} xmlSpace="preserve"
                >
                    <path fill={value.style?.fill || field.divider_color} d="M-0.5,28.6v0.9C1.4,28.1,21.8,14,53.8,6.9C84.7,0,133-1.7,187.7,29.6c36,20.6,69.3,27,96.8,27c14.5,0,27.3-1.8,38.1-4.2
                        c30.7-6.8,50.9-19.9,54.6-22.4v-0.9c-2,1.4-22.6,15.5-54.8,22.6c-31.1,7-79.6,8.6-134.3-22.7C133.1-2.4,84.6-0.7,53.6,6.2
                        C23.2,13,3.2,26.1-0.5,28.6L-0.5,28.6z"/>
                </svg>
            </div>
        default:
            return <></>
    }
    
}